import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { renderIf } from 'modules/render-if';
import classes from '../shared.scss';
import classNames from 'classnames';
import ValidationIcon from 'shared-components/FormFields/ValidationIcon';
import ValidationMessage from 'shared-components/FormFields/ValidationMessage';
import Tooltip from 'shared-components/ToolTip';

const VALID_TYPES = ['text', 'password', 'tel', 'number', 'email'];

const delegateEventHandler = (eventName, component) => {
  return (e) => {
    const val = e.target.value;
    if (component.props[eventName]) component.props[eventName](e, val);
  };
};

class InputField extends Component {
  onBlur = delegateEventHandler('onBlur', this);
  onChange = delegateEventHandler('onChange', this);
  onFocus = delegateEventHandler('onFocus', this);
  onInput = delegateEventHandler('onInput', this);
  onKeyDown = delegateEventHandler('onKeyDown', this);

  render() {
    const {
      label,
      className,
      isRequired,
      valid,
      error,
      tooltip,
      type,
    } = this.props;

    if (VALID_TYPES.indexOf(type) < 0) throw new Error('Invalid Input Type');

    const fieldClass = classNames({
      [classes.field]: true,
      [className]: typeof className === 'string',
    });

    const inputClass = classNames({ [classes.error]: valid === false });
    const inputProps = {
      ...this.props.input,
      className: inputClass,
      type,
      onBlur: this.onBlur,
      onChange: this.onChange,
      onFocus: this.onFocus,
      onInput: this.onInput,
      onKeyDown: this.onKeyDown,
    };

    const hasTooltip = Object.prototype.toString.call(tooltip) === '[object Object]';
    let tooltipProps = undefined;
    if (hasTooltip) tooltipProps = { ...tooltip, className: classes['input-tooltip'] };

    return (
      <div className={ fieldClass }>
        <label>
          <p>
            { label }
            { renderIf(isRequired)(() => (
              <abbr className={ classes.required } title="required">*</abbr>
            )) }
          </p>
          { renderIf(hasTooltip)(() => (
            <Tooltip { ...tooltipProps } />
          )) }
          <input { ...inputProps } />
          <ValidationIcon valid={ valid }/>
        </label>
        <ValidationMessage message={ error } />
      </div>
    );
  }
}

InputField.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
  }).isRequired,
  isRequired: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onInput: PropTypes.func,
  onKeyDown: PropTypes.func,
  tooltip: PropTypes.object,
  type: PropTypes.string.isRequired,
  valid: PropTypes.bool,
};

export default InputField;
